<section  id="form-section" class="section-container">
  <div class="section-content">
    <img [src]="bannerUrl" alt="banner promocional">

    <div class="login-form-container">
      <div class="login-form-card">
        <app-login-por-etapa (entrar)="handleLogin($event)" [networkError]="networkError" [loginLoading]="loginLoading"></app-login-por-etapa>
      </div>
    </div>
  </div>
</section>
